const getYearDifference = (year: number): number => {
  const currentYear = new Date().getFullYear()
  return currentYear - year
}

export { getYearDifference }
